module.exports = __webpack_public_path__ + "img/estacion viva 2.14323bad.png";